import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export function ServiceSchedules() {
  this.schedule = id => new Promise((resolve, reject) => {
    axios.get(`schedules/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
  this.scheduleSpecialist = id => new Promise((resolve, reject) => {
    axios.get(`schedules/specialist/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
  this.findByScheduleByCustomer = id => new Promise((resolve, reject) => {
    axios.post(`schedules/${id}/agoraio`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.updateSpecialistRoomStatus = (scheduleId, data) => new Promise((resolve, reject) => {
    axios.put(`schedules/${scheduleId}/update-status`, data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  // routes auth
  this.confirmarAgendamento = ({ data, customerId, sheduleId }) => new Promise((resolve, reject) => {
    axios.post(`schedules/auth/${customerId}/schedules/${sheduleId}/confirm`, data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.availableTimeSlots = data => new Promise((resolve, reject) => {
    axios.get('schedules/available-time-slots', { params: data })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.valueRefundService = id => new Promise((resolve, reject) => {
    axios.get(`schedules/auth/schedules/${id}/cancel`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.cancelByWallet = (id, userProfile) => new Promise((resolve, reject) => {
    axios.patch(`schedules/auth/schedules-by-wallet/cancel/${id}/${userProfile}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.refundService = id => new Promise((resolve, reject) => {
    axios.delete(`schedules/auth/schedules/${id}/cancel`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.refundSpecialistCancelService = (data) => new Promise((resolve, reject) => {
    axios.post(`schedules/auth/schedules/${data.id}/cancelPerSpecialist`, { data: data })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.refundCustomerCancelService = (data) => new Promise((resolve, reject) => {
    axios.delete(`schedules/auth/schedules/${data.id}/cancelPerCustomer`, { data: data })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.refundPaymentReversalPerCustomer = (data) => new Promise((resolve, reject) => {
    axios.delete(`schedules/auth/schedules/${data}/refund`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
